import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1151c994"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "team-overview-spacer" }
const _hoisted_4 = { class: "h1 m-0" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 1,
  class: "card no-team-card"
}
const _hoisted_7 = { class: "card-body d-flex flex-column text-center" }
const _hoisted_8 = { class: "h1 m-0" }
const _hoisted_9 = { class: "create-team-spacer" }
const _hoisted_10 = { class: "note" }
const _hoisted_11 = {
  href: "https://wooworlds.com/#1660225621201-16-2",
  target: "_blank"
}
const _hoisted_12 = {
  target: "_blank",
  href: "https://leaderboards.wooworlds.com/ww23/teamtotheight"
}
const _hoisted_13 = {
  key: 2,
  class: "card top-0 bottom-0 m-4 d-inline-block"
}
const _hoisted_14 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_widget_container_modal = _resolveComponent("widget-container-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_lottie_animation, {
          key: 0,
          class: "loading-animation",
          animationData: require('@/assets/animations/loader.json'),
          loop: true,
          autoPlay: true,
          speed: 1
        }, null, 8, ["animationData"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card invitations-card", { clickable: !_ctx.hasEnded && _ctx.invitesCount > 0 }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInvitationsModal()))
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_i18n_t, { keypath: "homepage.invitations_card" }, {
                      invitations_count: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.invitesCount), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('homepage.team')), 1),
                  (_ctx.teamName)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["card team-card", { clickable: !_ctx.hasEnded }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTeamModal()))
                      }, [
                        _createElementVNode("div", _hoisted_5, "#" + _toDisplayString(_ctx.teamName), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('homepage.no_team')), 1),
                          (!_ctx.hasEnded)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!_ctx.isLive)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('homepage.no_team_sub')), 1),
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-outline-light",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCreateTeamModal()))
                                        }, _toDisplayString(_ctx.$t('homepage.create_team_button')), 1)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('general.note')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('general.note_text')), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('general.if_you_have_questions')) + " ", 1),
                        _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('general.frequently_asked_questions')), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('general.view_teams')) + " ", 1),
                      _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('general.here')), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "logged-as",
                      onDblclick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enableTestDateChanger && _ctx.enableTestDateChanger(...args)))
                    }, "Logged in as: " + _toDisplayString(_ctx.sessionInfo?.email), 33)
                  ])
                ])
              ], 64))
        ], 64)),
    (_ctx.showTestDateChanger)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.testDate) = $event)),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeTestDate && _ctx.changeTestDate(...args)))
            }, null, 544), [
              [_vModelText, _ctx.testDate]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_widget_container_modal)
  ], 64))
}